import React from 'react'
import { ListNav } from './index'
import { SidebarBasic, AlertEmpty } from '../../../components'
import { useSelector } from 'react-redux'
import PaginatedList from './paginated-list'
import { USE_PAGINATION_API } from '../config'

const MainContent = () => {
  const [localOrganizations, setLocalOrganizations] = React.useState([])
  const {data: organizations} = useSelector(state => state.organizations)
  const query = useSelector(state => state.organizations.query)
  const { keyword } = query

  React.useEffect(() => {
    if (keyword) {
      const filtered = organizations.filter(org => org.name.toLowerCase().includes(keyword.toLowerCase()))
      console.log('fitered by keyword: ', filtered)
      setLocalOrganizations(filtered)
    } else {
      setLocalOrganizations(organizations)
    }
    // eslint-disable-next-line
  }, [])

  const data = USE_PAGINATION_API ? organizations : localOrganizations

  return (
    <section className="container mx-auto">
      <div className="flex flex-wrap -mx-4 py-16">
        <aside className="w-3/12 px-4">
          <SidebarBasic query={query} />
        </aside>
        <main className="w-9/12 px-4">
          {
            (data && data.length > 0) ? (
              <React.Fragment>
                <ListNav />
                <PaginatedList
                  query={query}
                  defaultData={data}
                />
              </React.Fragment>
            ) : (
              <AlertEmpty />
            )
          }
        </main>
      </div>
    </section>
  )
}

export { MainContent }
